import RestService from "./rest.service";

class adminService {
  checkCode(type, code, cycle = null) {
    return new Promise((fnResolve, fnReject) => {
      let url = `app/admin/kpi/validate/code/${type}?code=${code}`
      if (cycle) url += '&cycle=' + cycle

      RestService.gets(url).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalLibraryGoalItemByGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/group/${serial}/master`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalLibraryGoalItem(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/subgroup/${serial}/master`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailGoalLibraryGoalItem(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/master/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalLibraryGoalItem(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/master/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalLibraryGoalItem(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/master/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalLibraryGoalItem(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/master/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalMetric() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/goals/dropdown/mygoalMetric`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/library/${serial}/group`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailGoalGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/group/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createTargetGroup(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/target_group/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editTargetGroup(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/target_group/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteTargetGroup(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/target_group/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailTargetGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/target_group/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalGroup(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/group/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalGroup(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/group/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalGroup(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/group/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  listJobData(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getListJobData(`app/admin/kpi/users/job?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listTargetGroup() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/target_group`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalLibrary(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/library?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listEvaluateType() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getListEvaluateType(`app/admin/kpi/evaluate/type`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalCategory(competencyFormSelectValue) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/category?cycle_id=${competencyFormSelectValue}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalProgressGroup(competencyFormSelectValue) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/progress_group?cycle_id=${competencyFormSelectValue}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalProgress(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/progress_group/${serial}/progress`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailGoalProgressGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/progress_group/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailGoalProgress(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/progress/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailGoalCategory(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/category/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  evaluationType(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getListEvaluateType(`app/admin/kpi/evaluate/type/${data}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  updateGoalsCategory(data, cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/category/seq`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalsProgress(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/progress/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalsProgressGroup(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/progress_group/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalsCategory(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/category/${serial}`, data).then(
        // RestService.put(`app/admin/kpi/goals/category/seq?cycle_id=${cycle_id}`,data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  updateGoalsProgress(data, cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/progress/seq`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createEvaluatiion(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.post(`app/admin/kpi/evaluate/type/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalProgress(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/progress/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalComponent(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/category/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalProgressGroup(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/progress_group/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editEvaluatiion(id, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/evaluate/type/` + id, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getCategory() {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/category`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteEvaluatiion(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/evaluate/type/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalProgress(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/progress/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalCategory(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/category/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalProgressGroup(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/progress_group/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listCycle(opt = {}) {
    return new Promise((fnResolve, fnReject) => {
      let url = 'app/kpi/evaluate/dropdown/cycle'
      if (Object.keys(opt).length > 0) {
        let args = [];
        for (const fld in opt) args.push(fld + '=' + opt[fld]);
        url += '?' + args.join('&')
      }


      RestService.getListCycle(url).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listCycleMain() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getListCycle("app/admin/kpi/evaluate/cycle").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createCycle(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.post(`app/admin/kpi/evaluate/cycle/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEditCycle(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/evaluate/cycle/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editCycle(id, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/evaluate/cycle/${id}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteCycle(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/evaluate/cycle/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailJobData(serial, cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getDetailJobData(`app/admin/kpi/users/job/${serial}?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listPosition(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getListPosition(`app/admin/kpi/users/position?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailPosition(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getDetailPosition(`app/admin/kpi/users/position/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  currentEmployees(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getCurrentEmployees(`app/admin/kpi/users/position/${serial}/job`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  goalLibrary(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/library/${data}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalLibrary(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.post(`app/admin/kpi/goals/library/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalLibrary(id, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/library/` + id, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalLibrary(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/library/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listIcon() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/config/component`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listSubCriteria(criteria) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/target_group/criteria/${criteria}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  criteriaPreview(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/target_group/criteria/preview`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listCriteria() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/target_group/add`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listGoalSubGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/group/${serial}/subgroup`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailGoalSubGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/goals/subgroup/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createGoalSubGroup(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/goals/subgroup/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editGoalSubGroup(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/goals/subgroup/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteGoalSubGroup(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/goals/subgroup/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listEvaluationJoruney(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/evaluationjourney?cycle_id=` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listEvaluationJoruneyCycle() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/evaluationjourney/dropdown/cycle`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  listEvaluationJoruneyTemplate(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/evaluationjourney/dropdown/evaluate_template/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  listEvaluationJoruneyGoalTemplate(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/evaluationjourney/dropdown/goal_template/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  listEvaluationJoruneyCompetencyTemplate(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/evaluationjourney/dropdown/competency_template/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createEvaluationJourney(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/evaluationjourney`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteEvaluatiionJourney(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/evaluationjourney/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEvaluatiionJourney(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.get(`app/admin/evaluationjourney/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  updateEvaluatiionJourney(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/evaluationjourney/` + serial, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getCheckEvaluatiionJourneyCode(code) {
    return new Promise((fnResolve, fnReject) => {
      RestService.get(`app/admin/kpi/validate/code/evaluate_journey?code=` + code).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getCycleConfig() {
    return new Promise((fnResolve, fnReject) => {
      RestService.get(`app/admin/kpi/evaluate/cycle-conf`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new adminService();
